import { Container, Row, Col } from "react-grid-system"
import H3 from "../../../atoms/typography/H3"
import { theme } from "../../../theme"
import React from "react"
import styled from "styled-components"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"

export interface TerminalColorPickerProps {
  product: "ku" | "secure"
}

const ColorSwatch = styled.div<{ color: string; name: string; active?: boolean }>`
  width: 36px;
  height: 36px;
  background-color: ${(props) => props.color};
  border-radius: 32px;
  box-shadow: 0px 2px 6px 0px #77777740;
  border: ${(props) => (props.active ? `4px solid ${theme.colors.white}` : "none")};
  position: relative;
  box-sizing: border-box;

  &::after {
    content: "${(props) => (props.active ? props.name : "")}";
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;

    /* Body Text */
    color: ${(props) => props.theme.colors.greyDark};
    text-align: center;
    font-family: "Karla", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
  }
`

export const KU_COLORS = {
  sand: {
    name: "Sand",
    color: theme.terminalColors.sand,
    img: "https://images.ctfassets.net/kzqg847wz5jr/1d3XAOqtQoDLpR3pDGzUUY/db00969ae0cab6fee135e878d7c75009/Ku_sand.webp",
  },
  moss: {
    name: "Moss",
    color: theme.terminalColors.moss,
    img: "https://images.ctfassets.net/kzqg847wz5jr/63Gc400u2Y30eo3OshdC3M/d6a5091d7fa2ada1c49f7d4e6fa630d2/Ku_moss.webp",
  },
  standard: {
    name: "Grey",
    color: theme.terminalColors.standard,
    img: "https://images.ctfassets.net/kzqg847wz5jr/1BmA9dfA759CCeSpAiRRz2/60d0ecd00044cf267eeceb9ac48859c6/Ku_standard.webp",
  },
}

export const SECURE_COLORS = {
  sand: {
    name: "Sand",
    color: theme.terminalColors.sand,
    img: "https://images.ctfassets.net/kzqg847wz5jr/63Gc400u2Y30eo3OshdC3M/d6a5091d7fa2ada1c49f7d4e6fa630d2/Ku_moss.webp",
  },
  moss: {
    name: "Moss",
    color: theme.terminalColors.moss,
    img: "https://images.ctfassets.net/kzqg847wz5jr/63Gc400u2Y30eo3OshdC3M/d6a5091d7fa2ada1c49f7d4e6fa630d2/Ku_moss.webp",
  },
  standard: {
    name: "Grey",
    color: theme.terminalColors.standard,
    img: "https://images.ctfassets.net/kzqg847wz5jr/63Gc400u2Y30eo3OshdC3M/d6a5091d7fa2ada1c49f7d4e6fa630d2/Ku_moss.webp",
  },
}

export const TerminalColorPicker: React.FC<TerminalColorPickerProps> = ({ product = "ku" }) => {
  const colors = product === "ku" ? KU_COLORS : SECURE_COLORS

  const [activeColor, setActiveColor] = React.useState(Object.values(colors)[0])

  const handleColorClick = (color: (typeof colors)[keyof typeof colors]) => {
    setActiveColor(color)
  }

  return (
    <Row justify="center">
      <Col xs="content">
        <Row justify="center">
          <img width={200} height={300} src={activeColor.img} />
        </Row>
        <HorizontalSpacer spacing={1} />
        <H3>Available in three colors:</H3>
        <HorizontalSpacer spacing={1} />
        <Row justify="between">
          {Object.values(colors).map((color) => (
            <Col key={color.name}>
              <ColorSwatch
                name={color.name}
                color={color.color}
                active={activeColor.color === color.color}
                onClick={() => handleColorClick(color)}
              />
            </Col>
          ))}
        </Row>
        <HorizontalSpacer spacing={2} />
      </Col>
    </Row>
  )
}
